module.exports = __webpack_public_path__ + "img/aichallenge.8e077440.jpg";